{
    "picker__title": "Period",
    "option__today": "Today",
    "option__yesterday": "Yesterday",
    "option__last_week": "Past week",
    "option__last_month": "Past month",
    "option__last_quarter": "Past 3 months",
    "option__ttm": "Past 12 months",
    "option__ytd": "Year to date",
    "option__full_year": "Full year",
    "option__custom": "Custom dates"
}
